import { render, staticRenderFns } from "./WestWalletTab.vue?vue&type=template&id=75ac7ec0&scoped=true"
import script from "./WestWalletTab.vue?vue&type=script&lang=js"
export * from "./WestWalletTab.vue?vue&type=script&lang=js"
import style0 from "./WestWalletTab.vue?vue&type=style&index=0&id=75ac7ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac7ec0",
  null
  
)

export default component.exports